import { Component } from 'react';
import styled from 'styled-components';

const TOAST_DURATION = 2000;

interface ToastProps {}

export interface ToastContent {
  message?: string | null;
}
interface ToastState extends ToastContent {
  isVisible: boolean;
  timerID?: ReturnType<typeof setTimeout> | null;
}

const initialState: ToastState = {
  isVisible: false,
  message: null,
  timerID: null,
};

class Toast extends Component<ToastProps, ToastState> {
  state = initialState;

  static _ref = null as Toast | null;

  static setRef(ref = null) {
    Toast._ref = ref;
  }

  static show(message: string) {
    Toast._ref?.show(message);
  }

  show(message: string) {
    const newState: ToastState = {
      isVisible: true,
      message,
    };

    this.setState(newState);

    setTimeout(() => {
      this.close();
    }, TOAST_DURATION);
  }

  close() {
    this.setState(initialState);
  }

  render() {
    const { isVisible, message } = this.state;

    return (
      isVisible && (
        <Background>
          <Container>
            <Icon src='/icons/check.svg' alt='check_icon' />
            <Message>{message}</Message>
          </Container>
        </Background>
      )
    );
  }
}

export default Toast;

const Background = styled.div`
  position: fixed;
  bottom: 90px;
  z-index: 99999;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  left: 0px;
  right: 0px;
  padding: 0 20px;
`;

const Container = styled.div`
  display: flex;
  padding: 20px;
  background-color: #181818bf;
  border-radius: 4px;
  z-index: 10000000000;
  align-self: center;
  flex-direction: row;
`;

const Icon = styled.img``;

const Message = styled.div`
  font-family: 'Pretendard-700';
  color: white;
  margin-left: 6px;
  flex: 1;
`;
